import { render } from "./PeriodComparisonFilter.vue?vue&type=template&id=1b015faf&scoped=true"
import script from "./PeriodComparisonFilter.vue?vue&type=script&lang=js"
export * from "./PeriodComparisonFilter.vue?vue&type=script&lang=js"

import "./PeriodComparisonFilter.vue?vue&type=style&index=0&id=1b015faf&scoped=true&lang=css"
/* custom blocks */
import block0 from "./PeriodComparisonFilter.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_36ffa97d%2Fpackages%2Fstore%2Fsrc%2Fcomponents%2Fanalytics%2FPeriodComparisonFilter.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b015faf"]])

export default __exports__